import './pre-footer.scss';

/**
 * version    1.0
 * class      <type> (PreFooter)
 * classdesc  Pre Footer: contains 3 column, 2 with informations and last one with newsletter form
 */
export class PreFooter {}
